
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "buildId": "912d958cfebe0b29dc4530fd8fa9571f3ecf8fbb",
  "nuxt": {
    "buildId": "e16a40b5-00ab-4305-91bf-cfc2652fb617"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
